var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".article-aspiration-medical-container[data-v-2aa91dae]{background-image:url(" + escape(require("../assets/home/aspiration-medical-bg.png")) + ");background-repeat:no-repeat;background-position:bottom;background-size:auto 1365px}", ""]);

// exports
